class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
  
  // 1. Update cart drawer
  if (parsedState.sections?.['cart-drawer']) {
    const html = parsedState.sections['cart-drawer'];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const drawerInner = doc.querySelector('.drawer__inner');
    
    if (drawerInner) {
      const currentDrawerInner = document.querySelector('.drawer__inner');
      if (currentDrawerInner) {
        currentDrawerInner.innerHTML = drawerInner.innerHTML;
      }
    }
  }
  
  // 2. Update notification popup content
  if (parsedState.sections?.['cart-notification']) {
    const html = parsedState.sections['cart-notification'];
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Extract the product info div from the response
    const responseNotification = doc.querySelector('.cart-notification');
    if (responseNotification) {
      const productDiv = responseNotification.querySelector('.cart-notification-product');
      const targetProductDiv = document.getElementById('cart-notification-product');
      
      if (productDiv && targetProductDiv) {
        targetProductDiv.innerHTML = productDiv.innerHTML;
      }
    }
  }
  
  this.open();
}

  getSectionInnerHTML(html, selector) {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const el = doc.querySelector(selector);
  if (!el) {
    return '';
  }
  return el.innerHTML;
}


  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
